export const expertiseItems = [
  {
    num: '01',
    slug: 'roth-conversions',
    title: 'Roth Conversions — Pay Once, Never Again',
    body: 'Roth conversions should be done at any age — especially around 35. The misconception about the 10% early withdrawal penalty? Don\'t withdraw. Move it into an IRA account, pay taxes on the conversion only, and your principal stays intact. Taxes will go up — the country\'s debt gives them no choice. Why pay more later when you can pay less now? After conversion, the growth is entirely tax-free, and when passed to your spouse or family, there\'s no tax burden at all.',
    pill: 'Tax-Free Growth · Legacy Planning · Zero Future Tax Burden',
  },
  {
    num: '02',
    slug: 'long-term-care',
    title: 'Long-Term Care — $100K Becomes $300K in Care Dollars',
    body: '$100,000 in qualified money can become $300,000 in long-term care dollars. Add the lifetime care rider and you have coverage that never runs out. And the best part? Don\'t use it, don\'t lose it — the full value passes to your beneficiaries if care is never needed. This is one of the most overlooked and powerful strategies available today.',
    pill: 'Lifetime Coverage · 3x Care Dollars · Beneficiary Protection',
  },
  {
    num: '03',
    slug: 'life-insurance',
    title: 'Life Insurance — Tax-Free Income for Life',
    body: 'Today\'s life insurance is not life insurance — it\'s what we call a leaving strategy. Done right, it gives you tax-free income in retirement, funds for college planning, and peace of mind knowing your family is cared for if you\'re not there. Enjoy tax-free dollars in retirement and pass on a legacy without the burden of taxes. This is a strategy, not just a policy.',
    pill: 'Tax-Free Retirement Income · College Planning · Family Protection',
  },
  {
    num: '04',
    slug: 'annuities',
    title: 'Annuities — Guaranteed Income. You Never Lose.',
    body: 'With the correct annuity structure you never lose money. Add a rider and you unlock enhanced benefits if you become disabled and can no longer perform two of your daily activities — a protection most people never think about until it\'s too late. Choose guaranteed lifetime income, or don\'t draw it and pass the full value to your beneficiaries.',
    pill: 'Guaranteed Income · Disability Rider · Legacy Transfer',
  },
];

export const testimonials = [
  {
    quote: 'The Roth conversion strategy alone saved my family from years of unnecessary taxes. I wish I had found this advisor a decade ago.',
    initials: 'RJ',
    name: 'Robert J.',
    role: 'Business Owner · Roth Conversion',
  },
  {
    quote: 'The MSO setup was a game-changer. I\'m deducting premiums I never knew I could deduct. My CPA was stunned.',
    initials: 'ML',
    name: 'Michelle L.',
    role: 'Physician · MSO Strategy',
  },
  {
    quote: 'I moved $100K into long-term care and now have $300K in coverage with lifetime care. The \'don\'t use it, don\'t lose it\' was the deciding factor.',
    initials: 'DW',
    name: 'David W.',
    role: 'Executive · Long-Term Care',
  },
  {
    quote: 'My estate plan was a mess. Now I have a trust, health will, and medical will. It took one meeting and I\'m sleeping better knowing my family is covered.',
    initials: 'SC',
    name: 'Sandra C.',
    role: 'Attorney · Trust Planning',
  },
  {
    quote: 'Tax-free income in retirement sounded too good to be true. Now I\'m living it. The life insurance strategy is unlike anything my previous advisor mentioned.',
    initials: 'TM',
    name: 'Thomas M.',
    role: 'Retired Executive · Life Insurance',
  },
];

export const books = [
  {
    title: 'Escape the Trap: A Secret Guide to Keeping More of What You Earn',
    desc: 'Discover how to design a retirement income strategy that lasts — with zero market risk and maximum tax efficiency.',
    image: '/book1.webp',
  },
  {
    title: 'A Pure Vision: Today Secures Your Tomorrow and Beyond',
    desc: 'A step-by-step guide to legally minimising your tax burden and keeping more of what you\'ve worked a lifetime to earn.',
    image: '/book2.jpg',
  },
  {
    title: 'The Tax-Free Solution for Long-Term Planning',
    desc: 'Learn how to protect your estate, avoid probate, and pass on generational wealth to the people you love most.',
    image: '/book3.jpg',
  },
  {
    title: 'Facts about Roth and Your Future',
    desc: '',
    image: '/book4.png',
  },
  {
    title: 'Fact on how Life Insurance Policies Work. Tax-Free',
    desc: '',
    image: '/book5.jpg',
  },
  {
    title: 'Will or Trust? Tomorrow is Now',
    desc: '',
    image: '/Book6.jpeg',
  },
  {
    title: 'Social Security Is Annuity: Love All, Serve All',
    desc: '',
    image: '/Book7.jpeg',
  },
];

export const logoItems = [
  { name: 'PARTNER CO',   w: 120,
    shape: `<rect x="2" y="8" width="24" height="24" rx="4" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 20 L14 14 L20 20 L26 14" stroke="currentColor" stroke-width="1.5" fill="none"/><text x="34" y="25" font-family="'Syne',sans-serif" font-size="13" font-weight="700" fill="currentColor" letter-spacing="0.5">PARTNER CO</text>` },
  { name: 'WEALTHVAULT', w: 110,
    shape: `<circle cx="20" cy="20" r="12" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="20" cy="20" r="5" fill="currentColor"/><text x="38" y="25" font-family="'Syne',sans-serif" font-size="13" font-weight="700" fill="currentColor" letter-spacing="0.5">WEALTHVAULT</text>` },
  { name: 'APEXFUND',    w: 100,
    shape: `<polygon points="20,6 34,30 6,30" fill="none" stroke="currentColor" stroke-width="1.5"/><text x="40" y="25" font-family="'Syne',sans-serif" font-size="13" font-weight="700" fill="currentColor" letter-spacing="0.5">APEXFUND</text>` },
  { name: 'MERIDIAN GRP',w: 120,
    shape: `<path d="M6 20 Q13 8 20 20 Q27 32 34 20" stroke="currentColor" stroke-width="1.5" fill="none"/><text x="42" y="25" font-family="'Syne',sans-serif" font-size="13" font-weight="700" fill="currentColor" letter-spacing="0.5">MERIDIAN GRP</text>` },
  { name: 'CORNERSTONE', w: 110,
    shape: `<rect x="6" y="12" width="16" height="16" rx="2" fill="currentColor" opacity="0.15"/><rect x="6" y="12" width="16" height="16" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><line x1="14" y1="12" x2="14" y2="28" stroke="currentColor" stroke-width="1.5"/><line x1="6" y1="20" x2="22" y2="20" stroke="currentColor" stroke-width="1.5"/><text x="32" y="25" font-family="'Syne',sans-serif" font-size="13" font-weight="700" fill="currentColor" letter-spacing="0.5">CORNERSTONE</text>` },
  { name: 'NEXUSPLAN',   w: 100,
    shape: `<path d="M20 8 L32 20 L20 32 L8 20 Z" fill="none" stroke="currentColor" stroke-width="1.5"/><text x="40" y="25" font-family="'Syne',sans-serif" font-size="13" font-weight="700" fill="currentColor" letter-spacing="0.5">NEXUSPLAN</text>` },
  { name: 'TRUEWEALTH',  w: 110,
    shape: `<path d="M8 28 L14 12 L20 22 L26 16 L32 28" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linejoin="round"/><text x="40" y="25" font-family="'Syne',sans-serif" font-size="13" font-weight="700" fill="currentColor" letter-spacing="0.5">TRUEWEALTH</text>` },
  { name: 'CERTIPRO',    w: 100,
    shape: `<circle cx="20" cy="20" r="12" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M14 20 L18 24 L26 16" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/><text x="38" y="25" font-family="'Syne',sans-serif" font-size="13" font-weight="700" fill="currentColor" letter-spacing="0.5">CERTIPRO</text>` },
];
